import { render } from "./RiskRatingCard.vue?vue&type=template&id=7c3f3703&scoped=true"
import script from "./RiskRatingCard.vue?vue&type=script&lang=js"
export * from "./RiskRatingCard.vue?vue&type=script&lang=js"

import "./RiskRatingCard.vue?vue&type=style&index=0&id=7c3f3703&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3f3703"]])

export default __exports__